import { FormInput, SvgInfo } from '@ui-kit'
import {
  NAMESPACES,
  OCR_PAGE_VERSION,
  OCR_TAB_SWITCH_WARNING,
} from '../../../utils/constants'
import { OCRPageGlobalHeaderProps } from '../../../types/ocr.types'

const OCRPageGlobalHeader: React.FC<OCRPageGlobalHeaderProps> = ({
  pageReviewStatus,
}) => {
  return (
    <div className="flex flex-col gap-5">
      <div
        className="flex items-center gap-2 bg-ocr-warning-bg px-3 py-2 text-sm font-primary font-light"
        role="alert"
      >
        <SvgInfo className="flex-shrink-0 h-4 w-4 [&_path]:!fill-blue-500" />
        <span>{OCR_TAB_SWITCH_WARNING}</span>
      </div>

      <div className="grid grid-cols-3 gap-2 col-span-1 w-full">
        <FormInput
          name="ocr_page_status_display"
          label={NAMESPACES.OCR_STATUS_LABEL}
          disabled
          defaultValue={pageReviewStatus}
          required
          dataQaId="ocr_page_status_display"
          inputBorderClass="border border-solid border-accent-200"
        />
        <FormInput
          name="ocr_page_version_display"
          label={NAMESPACES.OCR_VERSION_LABEL}
          disabled
          defaultValue={OCR_PAGE_VERSION}
          required
          dataQaId="ocr_page_version_display"
          inputBorderClass="border border-solid border-accent-200"
        />
      </div>
    </div>
  )
}

export default OCRPageGlobalHeader
